import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    profile: {},
    loginStatus: false,
    userAccessToken: '',
    fbInitialized: false,
    pages: [],
    selectedPage: null,
  },
  mutations: {
    login(state, {status, accessToken}) {
      state.loginStatus = status;
      state.userAccessToken = accessToken;
    },
    profile(state, profile) {
      state.profile = profile;
    },
    fbInitialized(state, flag) {
      state.fbInitialized = flag;
    },
    pages(state, pages) {
      state.pages = pages;
    },
    setSelectedPage(state, selectedPage) {
      state.selectedPage = selectedPage;
    },
  },
  getters: {
    loginStatus: (state) => ({ status: state.loginStatus, accessToken: state.userAccessToken }),
    profile: (state) => state.profile,
    selectedPage: (state) => state.selectedPage,
  },
  actions: {

  },
});
